import React, { useState, useContext, useEffect, useRef } from "react";
import axios from "axios";
import "./MainSidebar.css";
import { AuthContext } from "../../../../contexts/AuthContext";
import { useNavigate, useLocation } from "react-router-dom";
import * as links from "../../../../utils/links";
import PwaInstallButton from "../../../PwaInstall/PwaInstallButton";
import telemetriaLogo from "../../../../assets/images/stronda_telemetria.png";

const Sidebar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [mensalidadeAlerta, setMensalidadeAlerta] = useState(false);
  const [mensalidadePiscaLigado, setMensalidadePiscaLigado] = useState(false);
  const [avisosSugestoes, setAvisosSugestoes] = useState(0);
  const touchStart = useRef(null);
  const location = useLocation();
  const { setDataUser, authInfo } = useContext(AuthContext);
  const navigate = useNavigate();
  const { dataUser } = authInfo;
  const toggleOpen = () => setIsOpen((aberto) => !aberto);

  useEffect(() => {
    const handleClickOutside = (event) => { if (isOpen && !event.target.closest(".sidebar")) setIsOpen(false); };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen]);

  useEffect(() => {
    let ativo = true;
    const servidor = process.env.REACT_APP_SERVIDOR;
    const token = dataUser?.token;
    const tipo = dataUser?.key;
    if (!servidor || !token || !tipo) { setMensalidadeAlerta(false); setAvisosSugestoes(0); return undefined; }
    const headers = { "x-access-token": token, "content-type": "application/json" };
    const atualizarIndicadores = async () => {
      if (tipo === "CLIENT") {
        const [mensalidade, sugestoes] = await Promise.allSettled([
          axios.get(`${servidor}/cliente-2027/resumo-extra`, { headers }),
          axios.get(`${servidor}/sugestoes-2026/cliente/resumo`, { headers }),
        ]);
        if (!ativo) return;
        if (mensalidade.status === "fulfilled") { const lembrete = mensalidade.value?.data?.mensalidade?.lembrete; setMensalidadeAlerta(lembrete === "VENCE_HOJE" || lembrete === "VENCIDO"); }
        if (sugestoes.status === "fulfilled") setAvisosSugestoes(Number(sugestoes.value?.data?.respostasNovas || 0));
      } else if (tipo === "ADMIN") {
        setMensalidadeAlerta(false);
        try { const sugestoes = await axios.get(`${servidor}/admin-2026/sugestoes/resumo`, { headers }); if (ativo) setAvisosSugestoes(Number(sugestoes?.data?.novas || 0)); }
        catch (_) { if (ativo) setAvisosSugestoes(0); }
      }
    };
    atualizarIndicadores();
    const timer = setInterval(atualizarIndicadores, 30000);
    return () => { ativo = false; clearInterval(timer); };
  }, [dataUser?.token, dataUser?.key, location.pathname]);

  useEffect(() => {
    if (!mensalidadeAlerta) { setMensalidadePiscaLigado(false); return undefined; }
    setMensalidadePiscaLigado(true);
    const timerPisca = setInterval(() => setMensalidadePiscaLigado((estadoAtual) => !estadoAtual), 650);
    return () => clearInterval(timerPisca);
  }, [mensalidadeAlerta]);

  const handleTouchStart = (event) => { const t = event.touches?.[0]; if (t) touchStart.current = { x:t.clientX, y:t.clientY }; };
  const handleTouchEnd = (event) => {
    if (!touchStart.current || window.innerWidth > 850) return;
    const t = event.changedTouches?.[0]; if (!t) return;
    const dx = t.clientX - touchStart.current.x; const dy = t.clientY - touchStart.current.y; touchStart.current = null;
    if (Math.abs(dx) < 45 || Math.abs(dx) <= Math.abs(dy) * 1.25) return;
    if (dx > 0) setIsOpen(true); else setIsOpen(false);
  };
  const ir = (rota) => { navigate(rota); if (window.innerWidth <= 800) setIsOpen(false); };
  const ativo = (rota) => location.pathname === rota;
  const classe = (...nomes) => nomes.filter(Boolean).join(" ");
  const clienteOuAdmin = dataUser?.key === "CLIENT" || dataUser?.key === "ADMIN";

  return <div className="sidebar-shell" onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd}>
    <aside className={`sidebar ${isOpen ? "open" : ""}`}><div className="inner">
      <div className="header"><button className="toggleButton sm-telemetria-logo" type="button" onClick={toggleOpen} aria-label={isOpen ? "Fechar menu" : "Abrir menu"}><img className="sm-app-logo" src={telemetriaLogo} alt="SM Telemetria" /></button>{isOpen && <div className="header-title open">STRONDA MUSIC</div>}</div>
      <nav className="menu">
        {dataUser?.key === "ADMIN" && <button className={ativo(links.ADMIN_CENTRAL) ? "active" : ""} type="button" onClick={() => ir(links.ADMIN_CENTRAL)}><i className="bi bi-speedometer2 large-icon"/><span>Central</span></button>}
        {dataUser?.key === "CLIENT" && <button className={ativo(links.CLIENTE_VISAO_GERAL) ? "active" : ""} type="button" onClick={() => ir(links.CLIENTE_VISAO_GERAL)}><i className="bi bi-speedometer2 large-icon"/><span>Visão Geral</span></button>}
        {dataUser?.key === "CLIENT" ? <button className={ativo(links.DASHBOARD_FORNECEDOR) ? "active" : ""} type="button" onClick={() => ir(links.DASHBOARD_FORNECEDOR)}><i className="bi bi-hdd-stack large-icon"/><span>Máquinas</span></button> : <button className={ativo(links.DASHBOARD_CLIENTES) ? "active" : ""} type="button" onClick={() => ir(links.DASHBOARD_CLIENTES)}><i className="bi bi-people large-icon"/><span>Clientes</span></button>}
        {dataUser?.key === "ADMIN" && <button className={ativo(links.LISTA_MAQUINAS) ? "active" : ""} type="button" onClick={() => ir(links.LISTA_MAQUINAS)}><i className="bi bi-hdd-stack large-icon"/><span>Máquinas</span></button>}
        {dataUser?.key === "ADMIN" && <button className={ativo(links.MENSALIDADES_ADM_LIST) ? "active" : ""} type="button" onClick={() => ir(links.MENSALIDADES_ADM_LIST)}><i className="bi bi-qr-code large-icon"/><span>Mensalidades</span></button>}
        {dataUser?.key === "CLIENT" && <button className={ativo(links.CLIENTE_PAGAMENTOS) ? "active" : ""} type="button" onClick={() => ir(links.CLIENTE_PAGAMENTOS)}><i className="bi bi-credit-card-2-front large-icon"/><span>Pagamentos</span></button>}
        {dataUser?.key === "CLIENT" && <button className={classe(ativo(links.CLIENTE_MENSALIDADES) && "active", mensalidadeAlerta && "mensalidade-alerta", mensalidadeAlerta && (mensalidadePiscaLigado ? "mensalidade-alerta-vermelho" : "mensalidade-alerta-normal"))} type="button" onClick={() => ir(links.CLIENTE_MENSALIDADES)} title={mensalidadeAlerta ? "Mensalidade vencida ou vencendo hoje" : "Mensalidades"}><i className="bi bi-qr-code large-icon"/><span>Mensalidades</span></button>}
        {clienteOuAdmin && <button className={classe(ativo(links.SUGESTOES) && "active", avisosSugestoes > 0 && "tem-aviso-sugestao")} type="button" onClick={() => ir(links.SUGESTOES)} title={avisosSugestoes > 0 ? `${avisosSugestoes} novidade(s) em sugestões` : "Sugestões"}><i className="bi bi-lightbulb large-icon"/><span>Sugestões</span>{avisosSugestoes > 0 && <b className="sidebar-badge">{avisosSugestoes > 99 ? "99+" : avisosSugestoes}</b>}</button>}
        {clienteOuAdmin && <button className={ativo(links.NEW_PASSWORD) ? "active" : ""} type="button" onClick={() => ir(links.NEW_PASSWORD)}><i className="bi bi-key large-icon"/><span>Trocar Senha</span></button>}
        <PwaInstallButton compact/>
        <button type="button" onClick={() => { navigate(links.SIGNIN); setDataUser(null); }}><i className="bi bi-box-arrow-right large-icon"/><span>Sair</span></button>
      </nav>
    </div></aside>
  </div>;
};
export default Sidebar;
